export default "__VITE_ASSET__nIqRYMca__"